import { makeFetchData } from "api/makeApiRequestType/makeFetchData";
import { validate, ValidationCallback } from "validation/validate";
import { FollowUpChecksParams } from "validation/getFieldChecker";

type Params = {};

export interface Country {
	code: string;
	name: string;
}

type Output = { countries: Country[] };

const flagValidationErrorsInCountry: ValidationCallback<Country> = (
	input,
	{ flag, checkField }
) => {
	checkField("code", { type: "string" });
	checkField("name", { type: "string" });
};

const flagValidationErrors: ValidationCallback<Output> = (
	input,
	{ checkField },
	auth
) => {
	checkField("countries", {
		type: "array",
		followUpChecks: arg => {
			const { findInvalid, value } = arg as FollowUpChecksParams<"array">;

			value.forEach((country, countryOffset) => {
				const errorMessagePrefix = `Country ${countryOffset}`;

				if (typeof country !== "object") {
					findInvalid(`${errorMessagePrefix}: not an object`);
					return;
				}

				validate(country, {
					doValidate: flagValidationErrorsInCountry,
					withErrors: errors => {
						findInvalid(`Row ${countryOffset}: ${JSON.stringify(errors)}`);
					},
					auth
				});
			});
		}
	});
};

export const getLocationCountries = makeFetchData<Params, Output>(
	"countries",
	flagValidationErrors,
	undefined,
	undefined,
	{ cacheInMemory: true }
);
